import { useQuery } from '@tanstack/react-query';

import { getConfigurationFeatures } from './configurationFeatures';

export const CONFIGURATION_FEATURES_KEY = 'ConfigurationFeatures';

export const useGetConfigurationFeatures = () => {
  return useQuery({
    queryKey: [CONFIGURATION_FEATURES_KEY],
    queryFn: getConfigurationFeatures,
  });
};
